import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Link from "@mui/material/Link";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { fetchThingDetails } from "features/thing/thingThunk";
import { useDispatch, useSelector } from "react-redux";
import JobRoleTable from "./jobRoleTable";

import { jobWorkTypesList } from "config/apis";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { jobReport } from "config/apis";
import { jobWork } from "config/apis";

function JobRoleReport() {
  const [reportData, setReportData] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
const [jobWorkTypes, setJobWorkTypes] = useState([]);
const [jobTypeLoading, setJobTypeLoading] = useState(false);

  const dispatch = useDispatch();
  const things = useSelector((state) => state.things.filterThing || []);

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // ✅ Updated Columns
  const columns = [
    { Header: "Vehicle No", accessor: "vehicleNo", width: "12%" },
    { Header: "Date", accessor: "date", width: "12%" },
    { Header: "Job Type", accessor: "jobType", width: "15%" },
    { Header: "Description", accessor: "description", width: "15%" },
    { Header: "Cost", accessor: "cost", width: "10%" },
    { Header: "Service Provider", accessor: "serviceProvider", width: "15%" },
    { Header: "Odometer", accessor: "odometer", width: "10%" },
    { Header: "Time Taken (mins)", accessor: "timeTaken", width: "10%" },
    { Header: "Invoice", accessor: "invoice", width: "10%" },
    { Header: "Action", accessor: "action", width: "10%" },
  ];

  const fetchReport = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setErrorMessage("Session expired. Please log in again.");
      openErrorSB();
      return;
    }

    if (!selectedVehicle) {
      setErrorMessage("Please select a vehicle.");
      openErrorSB();
      return;
    }

    setLoading(true);
    setErrorMessage("");

    const formatDate = (d) => {
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };

    const data = {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
      vehicleIds: [selectedVehicle.thingId],
    };

    const config = {
      method: "post",
      url: jobReport,
      headers: {
        "x-dhundhoo-session": token,
        "Content-Type": "application/json",
      },
      data,
    };

    try {
      const response = await axios.request(config);
      const result = response.data || [];

   
      const formattedRows = result.map((item, index) => ({
        id: item.dataId,
        vehicleNo: item.vehicleId,
        date: new Date(item.jobWorkDate).toLocaleDateString(),
        jobType: item.jobWorkType,
        description: item.description,
        cost: item.cost,
        serviceProvider: item.serviceProvider,
        odometer: item.odometerReading ?? "-",
        timeTaken: item.timeTaken ?? "-",
//          invoice: (
//   <Link
//       href={item.invoiceUpload}
//       target="_blank"
//       rel="noopener noreferrer"
//       underline="hover"
//       sx={{
//         fontWeight: "bold",
//         color: "#1976d2",
//         cursor: "pointer",
//       }}
//     >
//       View Invoice
//     </Link>
// ),
invoice: item.invoiceUpload ? (
  <Link
    href={item.invoiceUpload}
    target="_blank"
    rel="noopener noreferrer"
    underline="hover"
    sx={{
      fontWeight: "bold",
      color: "#1976d2",
      cursor: "pointer",
    }}
  >
    View Invoice
  </Link>
) : (
  <span style={{ color: "gray", fontStyle: "italic" }}>No Invoice Available</span>
),

       
       
        action: (
          <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
            <IconButton
              size="small"
              color="success"
              onClick={() => handleEdit(item)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              color="error"
              onClick={() => handleDelete(item)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </MDBox>
        ),
      }));

      setReportData(formattedRows);
      openSuccessSB();
    } catch (error) {
      console.error("Job work report error:", error);
      setErrorMessage("Failed to load job work report");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

 useEffect(() => {
  const fetchJobWorkTypes = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    setJobTypeLoading(true);
    try {
      const response = await axios.get(jobWorkTypesList, {
        headers: { "x-dhundhoo-session": token },
      });

      const types = Object.entries(response.data).map(([key, value]) => ({
        key,
        label: value,
      }));

      setJobWorkTypes(types);
    } catch (error) {
      console.error("Error fetching job work types:", error);
    } finally {
      setJobTypeLoading(false);
    }
  };

  fetchJobWorkTypes();
}, []);


 
  const handleDelete = async (item) => {
  const token = localStorage.getItem("token");
  const dataId=item.dataId
  if (!token) {
    setErrorMessage("Session expired. Please log in again.");
    openErrorSB();
    return;
  }

  if (!window.confirm("Are you sure you want to delete this job work entry?")) {
    return; // cancel deletion
  }

  try {
    setEditLoading(true);

    const response = await axios.delete(`https://v3.dhundhoo.com/jobwork/${dataId}`, {
      headers: { "x-dhundhoo-session": token },
    });

    if (response.status === 200 || response.data?.success) {
      openSuccessSB(); // show "Deleted successfully"
      fetchReport(); // refresh table
    } else {
      setErrorMessage(response.data?.message || "Failed to delete job work");
      openErrorSB();
    }
  } catch (err) {
    console.error("Delete Job Work Error:", err);
    setErrorMessage("Error while deleting job work");
    openErrorSB();
  } finally {
    setEditLoading(false);
  }
};


  const clearFilters = () => {
    setSelectedVehicle(null);
    setReportData([]);
    setErrorMessage("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const [editOpen, setEditOpen] = useState(false);
const [editLoading, setEditLoading] = useState(false);
const [editData, setEditData] = useState({
  vehicleNumber: "",
  jobWorkDate: "",
  jobWorkType: "",
  description: "",
  cost: "",
  serviceProvider: "",
  odometerReading: "",
  timeTaken: "",
  uploadInvoice: null,
  dataId: null,
});

const handleEdit = (item) => {
  setEditData({
    vehicleNumber: item.vehicleId,
    jobWorkDate: new Date(item.jobWorkDate).toISOString().split("T")[0],
    jobWorkType: item.jobWorkType,
    description: item.description,
    cost: item.cost,
    serviceProvider: item.serviceProvider,
    odometerReading: item.odometerReading,
    timeTaken: item.timeTaken,
    uploadInvoice: null,
    dataId: item.dataId, // 👈 from report API
  });
  setEditOpen(true);
};

const handleEditChange = (e) => {
  const { name, value, files } = e.target;
  if (name === "uploadInvoice") {
    setEditData({ ...editData, uploadInvoice: files[0] });
  } else {
    setEditData({ ...editData, [name]: value });
  }
};

const handleEditSubmit = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    setErrorMessage("Session expired. Please log in again.");
    openErrorSB();
    return;
  }

  setEditLoading(true);

  const jsonData = {
    dataId: editData.dataId,
    vehicleId: editData.vehicleNumber,
    jobWorkDate: new Date(editData.jobWorkDate).toISOString(),
    jobWorkType: editData.jobWorkType,
    description: editData.description,
    cost: parseFloat(editData.cost),
    serviceProvider: editData.serviceProvider,
    odometerReading: parseInt(editData.odometerReading || 0, 10),
    timeTaken: parseFloat(editData.timeTaken || 0),
    invoiceUpload: editData.uploadInvoice
      ? editData.uploadInvoice.name
      : undefined,
  };

  const submitData = new FormData();
  submitData.append(
    "data",
    new Blob([JSON.stringify(jsonData)], { type: "application/json" })
  );
  if (editData.uploadInvoice) {
    submitData.append("file", editData.uploadInvoice);
  }

  try {
    const response = await axios.put(jobWork, submitData, {
      headers: { "x-dhundhoo-session": token },
    });

    if (response.data) {
console.log('1',response.data)
      openSuccessSB();
      setEditOpen(false);
      fetchReport(); // refresh table
    } else {
      setErrorMessage(response.data?.message || "Failed to update job work");
      openErrorSB();
    }
  } catch (err) {
    console.error("Edit Job Work Error:", err);
    setErrorMessage("Error while updating job work");
    openErrorSB();
  } finally {
    setEditLoading(false);
  }
};


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={3} pb={0}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Grid container spacing={2}>
                    {/* Vehicle Select */}
                    <Grid item xs={12} sm={6} md={4}>
                      <Autocomplete
                        options={Array.isArray(things) ? things : []}
                        getOptionLabel={(option) =>
                          option?.nickName || option?.name || option?.thingId || "Unnamed Vehicle"
                        }
                        value={selectedVehicle}
                        onChange={(event, newValue) => setSelectedVehicle(newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Vehicle"
                            fullWidth
                            size="small"
                            sx={{ backgroundColor: "white", borderRadius: 1 }}
                          />
                        )}
                      />
                    </Grid>

                    {/* Start Date */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth size="small" />
                        )}
                      />
                    </Grid>

                    {/* End Date */}
                    <Grid item xs={12} sm={6} md={3}>
                      <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth size="small" />
                        )}
                      />
                    </Grid>

                    {/* Buttons */}
                    <Grid item xs={6} sm={3} md={1}>
                      <MDButton
                        fullWidth
                        variant="gradient"
                        color="warning"
                        size="small"
                        onClick={fetchReport}
                        disabled={loading}
                      >
                        {loading ? <CircularProgress size={20} color="inherit" /> : "LOAD"}
                      </MDButton>
                    </Grid>

                    <Grid item xs={6} sm={3} md={1}>
                      <MDButton
                        fullWidth
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={clearFilters}
                        disabled={loading}
                      >
                        CLEAR
                      </MDButton>
                    </Grid>
                  </Grid>
                </LocalizationProvider>
              </MDBox>

              {/* Error Alert */}
              {errorMessage && (
                <MDBox px={2} pt={2}>
                  <Alert severity="error">{errorMessage}</Alert>
                </MDBox>
              )}

              {/* Loader or Table */}
              <MDBox pt={3} display="flex" justifyContent="center">
                {loading ? (
                  <CircularProgress />
                ) : (
                  <JobRoleTable
                    table={{ columns, rows: reportData }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
<Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="md" fullWidth>
  <DialogTitle>Edit Job Work</DialogTitle>
  <DialogContent>
    <Grid container spacing={2} mt={1}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Vehicle Number"
          name="vehicleNumber"
          value={editData.vehicleNumber}
          onChange={handleEditChange}
          fullWidth
          disabled
        />
      </Grid>
<Grid item xs={12} sm={6}>
  <Autocomplete
    options={jobWorkTypes}
    getOptionLabel={(option) => option.label || ""}
    loading={jobTypeLoading}
    value={
      jobWorkTypes.find((type) => type.key === editData.jobWorkType) || null
    }
    onChange={(event, newValue) =>
      setEditData({
        ...editData,
        jobWorkType: newValue ? newValue.key : "",
      })
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label="Job Work Type"
        fullWidth
        size="small"
        sx={{ backgroundColor: "white", borderRadius: 1 }}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {jobTypeLoading ? <CircularProgress size={18} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
</Grid>

      

      <Grid item xs={12} sm={6}>
        <TextField
          label="Job Work Date"
          name="jobWorkDate"
          type="date"
          value={editData.jobWorkDate}
          onChange={handleEditChange}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Cost"
          name="cost"
          type="number"
          value={editData.cost}
          onChange={handleEditChange}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Description"
          name="description"
          value={editData.description}
          onChange={handleEditChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Service Provider"
          name="serviceProvider"
          value={editData.serviceProvider}
          onChange={handleEditChange}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Odometer Reading"
          name="odometerReading"
          type="number"
          value={editData.odometerReading}
          onChange={handleEditChange}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          label="Time Taken (mins)"
          name="timeTaken"
          type="number"
          value={editData.timeTaken}
          onChange={handleEditChange}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MDButton
          variant="outlined"
          component="label"
          fullWidth
          color="info"
          sx={{
            backgroundColor: "white",
            borderRadius: 1,
            textTransform: "none",
          }}
        >
          {editData.uploadInvoice
            ? `Selected: ${editData.uploadInvoice.name}`
            : "Select New Invoice File"}
          <input
            type="file"
            name="uploadInvoice"
            accept=".pdf,.jpg,.png"
            hidden
            onChange={handleEditChange}
          />
        </MDButton>
      </Grid>
    </Grid>
  </DialogContent>

  <DialogActions sx={{ p: 2 }}>
    <MDButton
      variant="contained"
      color="info"
      onClick={handleEditSubmit}
      disabled={editLoading}
    >
      {editLoading ? <CircularProgress size={20} /> : "Update"}
    </MDButton>
    <MDButton variant="outlined" color="error" onClick={() => setEditOpen(false)}>
      Cancel
    </MDButton>
  </DialogActions>
</Dialog>

      {/* Snackbars */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Job Work Report"
        content="Data Loaded Successfully"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />
      <MDSnackbar
        color="error"
        icon="warning"
        title="Job Work Report"
        content={errorMessage || "Failed to load report"}
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </DashboardLayout>
  );
}

export default JobRoleReport;